import {deviceGroupConstants} from "../constants/device-group.constants";
import {deviceGroupService} from "../services/device-group.service";
import {modalActions} from "./modal.actions";

const getDeviceGroup = () => {
    return dispatch => {
        deviceGroupService.getList()
            .then(
                deviceGroupModel => {
                    dispatch({type: deviceGroupConstants.DEVICE_GROUP_LIST_SUCCESS, deviceGroupModel})
                },
                error => {
                    dispatch({type: deviceGroupConstants.DEVICE_GROUP_LIST_FAILURE});
                }
            );
    }
};

const getDeviceGroupDropDownList = () => {
    return dispatch => {
        dispatch({type: deviceGroupConstants.DEVICE_GROUP_DROPDOWN_REQUEST});
        deviceGroupService.getDropDownList()
            .then(
                dropdown => {
                    dispatch({type: deviceGroupConstants.DEVICE_GROUP_DROPDOWN_SUCCESS, dropdown})
                },
                error => {
                    dispatch({type: deviceGroupConstants.DEVICE_GROUP_DROPDOWN_FAILURE, error})
                }
            )
    }
};

const getDeviceGroupById = (deviceGroupId) => {
    return dispatch => {
        dispatch({type: deviceGroupConstants.DEVICE_GROUP_BY_ID_REQUEST});
        deviceGroupService.getElementById(deviceGroupId)
            .then(
                deviceGroupModel => {
                    dispatch({type: deviceGroupConstants.DEVICE_GROUP_BY_ID_SUCCESS, deviceGroupModel})
                },
                error => {
                    dispatch({type: deviceGroupConstants.DEVICE_GROUP_BY_ID_FAILURE});
                    console.log(error);
                }
            );
    }
};

const changeOrder = (deviceGroupId, direction) => {
    return dispatch => {
        deviceGroupService.changeOrder(deviceGroupId, direction)
            .then(
                () => {
                    dispatch(getDeviceGroup())
                },
                (error) => {
                    console.log(error)
                }
            )
    }
};

const addDeviceGroup = (deviceGroup) => {
    return dispatch => {
        deviceGroupService.addDeviceGroup(deviceGroup)
            .then(
                () => dispatch(getDeviceGroup()),
                (error) => console.log(error)
            )
    }
};

const editDeviceGroup = (deviceGroup) => {
    return dispatch => {
        deviceGroupService.editDeviceGroup(deviceGroup)
            .then(
                () => dispatch(getDeviceGroup()),
                (error) => console.log(error)
            )
    }
};

const assignDeviceToGroup = (deviceGroupId, networkDeviceList) => {
    return dispatch => {
        deviceGroupService.assignToGroup(deviceGroupId, networkDeviceList)
            .then(
                () => {
                    dispatch(getDeviceGroup());
                    dispatch(modalActions.hideModal());
                },
                (error) => console.log(error)
            )
    }
}

const removeDeviceGroup = (deviceGroupId) => {
    return dispatch => {
        deviceGroupService.removeDeviceGroup(deviceGroupId)
            .then(
                () => dispatch(getDeviceGroup()),
                (error) => console.log(error)
            )
    }
};

const clearStore = () => {
    return dispatch => {
        dispatch({type: deviceGroupConstants.DEVICE_GROUP_CLEAR_LIST})
    };
};

export const deviceGroupActions = {
    getDeviceGroup,
    getDeviceGroupDropDownList,
    getDeviceGroupById,
    assignDeviceToGroup,
    changeOrder,
    addDeviceGroup,
    editDeviceGroup,
    removeDeviceGroup,
    clearStore
};
